import React from "react";
import SelectField from "./SelectField";
import { PARENT_EMERGENCY_CONTACT_RELATIONSHIPS } from '@/constants/relationshipOptions';

interface ParentRelationshipFieldProps {
  id: string;
  name: string;
  value: string;
  onChange: (value: string) => void;
  label?: string;
  placeholder?: string;
  required?: boolean;
  error?: boolean | string;
  hint?: string;
  className?: string;
}

const ParentRelationshipField: React.FC<ParentRelationshipFieldProps> = ({
  id,
  name,
  value,
  onChange,
  label = "Relationship to Parent",
  placeholder = "Select relationship",
  required = false,
  error = false,
  hint,
  className = "",
}) => {
  return (
    <div className={className}>
      <SelectField
        id={id}
        name={name}
        label={label}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        error={error}
        hint={hint}
        options={PARENT_EMERGENCY_CONTACT_RELATIONSHIPS}
      />
    </div>
  );
};

export default ParentRelationshipField; 